export default "/img/EC.c85fca5cb2dde4d46c1765cf26a958e3.png";